import axios from 'axios'

const SendError = async (apiUrl, errParam, vmParam, infoParam) => {
  let fullPath = vmParam && vmParam.$route && vmParam.$route.fullPath
    ? vmParam.$route.fullPath
    : ''
    let tag = vmParam && vmParam.$route && vmParam.$vnode.tag
    ? vmParam.$vnode.tag
    : ''
  const err = JSON.stringify(errParam.stack ? errParam.stack : errParam)
  const vm = JSON.stringify({ fullPath, tag })
  const info = JSON.stringify(infoParam)
  const session = JSON.parse(localStorage.getItem('usuarioLogado'))

  if (tag.includes('vue-component-294-RecuperarSenha') && err.includes('mask'))
    return

  await axios
    .post(
      `${apiUrl}/FuncoesGerais.svc/sendError`,
      { cliCodigo: !session ? 0 : session.DadosCliente.CliCodigo, err, vm, info },
      { withCredentials: true }
    )
    .then((res) => res.data)
}

export default {
  SendError,
}
